/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
/**
 * @param {string} ref Encapsulated reference string. MUST NOT be null.
 * @class
 * @author Jakub Senko <jsenko@redhat.com>
 */
export class Reference {
    /*private*/ ref : string;

    /*private*/ abs : string;

    /*private*/ rel : string;

    public constructor(ref : string) {
        if(this.ref===undefined) this.ref = null;
        if(this.abs===undefined) this.abs = null;
        if(this.rel===undefined) this.rel = null;
        if(ref == null) throw Object.defineProperty(new Error(), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.IllegalArgumentException','java.lang.Exception'] });
        this.ref = ref;
        let parts : string[] = ref.split("#");
        if(parts.length === 0) {
            this.abs = ref;
            this.rel = null;
        } else if(parts.length === 2) {
            this.abs = /* equals */(<any>((o1: any, o2: any) => { if(o1 && o1.equals) { return o1.equals(o2); } else { return o1 === o2; } })("",parts[0]))?null:parts[0];
            this.rel = "#" + parts[1];
        } else {
            throw Object.defineProperty(new Error("Wrong reference format."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.IllegalArgumentException','java.lang.Exception'] });
        }
    }

    /**
     * @return {string} the original/full reference string.
     */
    public getRef() : string {
        return this.ref;
    }

    public getAbsPart() : string {
        return this.abs;
    }

    public getRelPart() : string {
        return this.rel;
    }

    public isRelative() : boolean {
        return this.abs == null;
    }

    /**
     * @return {string} a `name` of the referenced component, as parsed from the reference string.
     * @throws java.lang.RuntimeException if the reference does not contain relative part
     */
    public getName() : string {
        if(this.rel == null) throw Object.defineProperty(new Error("No relative part in the reference."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
        let parts : string[] = this.rel.split("/");
        return parts[parts.length - 1];
    }

    /**
     * @param {Reference} that other reference
     * @return {Reference} a new reference with the absolute part copied form the other one,
     * and relative from this one
     */
    public withAbsoluteFrom(that : Reference) : Reference {
        if(that.getAbsPart() == null) throw Object.defineProperty(new Error(), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.IllegalArgumentException','java.lang.Exception'] });
        return new Reference(that.abs + this.rel);
    }

    /**
     * 
     * @param {*} o
     * @return {boolean}
     */
    public equals(o : any) : boolean {
        if(this === o) return true;
        if(o == null || (<any>this.constructor) !== (<any>o.constructor)) return false;
        let reference : Reference = <Reference>o;
        return /* equals */(<any>((o1: any, o2: any) => { if(o1 && o1.equals) { return o1.equals(o2); } else { return o1 === o2; } })(this.ref,reference.ref));
    }

    /**
     * 
     * @return {number}
     */
    public hashCode() : number {
        return /* hashCode */(<any>((o: any) => { if(o.hashCode) { return o.hashCode(); } else { return o.toString().split('').reduce((prevHash, currVal) => (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0); }})(this.ref));
    }
}
Reference["__class"] = "io.apicurio.datamodels.openapi.visitors.dereference.Reference";



